import API from "core/api/axios/base";
import Customer2FaErrorHandler from "core/api/handler/Customer2FaErrorHandler";


export function getEmail(token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_X_CLIENT_KEY_2FA,
    },
  };

  return API.get(`${process.env.REACT_APP_CUSTOMER_2FA}`, config)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = Customer2FaErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}

export function SendToken(data) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_X_CLIENT_KEY_2FA,
    },
  };

  return API.post(`${process.env.REACT_APP_CUSTOMER_2FA}`, data, config)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = Customer2FaErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}

export function ReSendToken(data) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_X_CLIENT_KEY_2FA,
    },
  };

  return API.post(`${process.env.REACT_APP_CUSTOMER_2FA}/resend`, data, config)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = Customer2FaErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}

export function ValidateToken(data) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_X_CLIENT_KEY_2FA,
    },
  };

  return API.post(`${process.env.REACT_APP_CUSTOMER_2FA}/valid`, data, config)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = Customer2FaErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}
